export const usePaxStore = defineStore('pax', () => {
  const DEFAULT_VALUES = {
    selected: { adults: 1, children: 0, infants: 0, youngAdults: 0 },
    config: {
      adults: { min: 1, max: 10 },
      children: { min: 0, max: 8 },
      infants: { min: 0, max: 9 },
      youngAdults: { min: 0, max: 9 }
    }
  }
  const GROUP_BOOKING_THRESHOLD = 9

  const selected = ref({ ...DEFAULT_VALUES.selected })

  const selectConfig = ref({ ...DEFAULT_VALUES.config })

  const youngAdultsAvailable = ref(false)

  const passengerCount = computed(() => {
    return selected.value.adults + selected.value.children + selected.value.infants + selected.value.youngAdults
  })

  const isGroupBooking = computed(() => {
    return selected.value.adults + selected.value.children + selected.value.youngAdults > GROUP_BOOKING_THRESHOLD
  })

  const forcedOpen = ref(false)

  watch(
    () => selected.value.youngAdults,
    (value) => {
      const hasYoungAdults = !!value

      selectConfig.value.adults.min = hasYoungAdults ? 0 : 1

      if (!hasYoungAdults && selected.value.adults === 0) {
        selected.value.adults = 1
      }
    }
  )

  watch(
    () => youngAdultsAvailable.value,
    (available) => {
      if (!available) {
        selected.value.youngAdults = 0
      }
    }
  )

  const resetSelected = () => {
    selected.value = { ...DEFAULT_VALUES.selected }
  }

  return {
    selected,
    selectConfig,
    youngAdultsAvailable,
    passengerCount,
    isGroupBooking,
    resetSelected,
    forcedOpen
  }
})
